import React from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
} from '@mui/material';

const ShippingPolicy = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper elevation={1} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom color="primary">
          Shipping and Delivery Policy
        </Typography>
        
        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          General
        </Typography>
        
        <Box component="ol" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1" paragraph>
            We provide shipping and delivery of our Products all over India. We aim to provide the best customer experience for you by tying-up and partnering with leading logistics service providers to handle your order in the best possible way and to ensure that you have a hassle-free experience in receiving the Product that you have ordered from the Platform. We make all commercially reasonable endeavours to ensure that the Products are delivered to you in a timely fashion.
          </Typography>
          <Typography component="li" variant="body1" paragraph>
            By agreeing to use the Platform and/ or purchasing a Product on the Platform, you agree to be bound by the terms of this Policy without modification. We encourage you to read and understand the terms of this Policy every time you visit the Platform. If you do not agree to the terms contained in this Policy, you are advised not to use, access or transact on the Platform.
          </Typography>
        </Box>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          Terms of Shipping and Delivery
        </Typography>
        
        <Box component="ol" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1" paragraph>
            We partner with Shiprocket and other third party logistic service providers ("Logistic Partners") in order to effectuate Product shipping and delivery to you. We shall provide the details of the Logistic Partners which will be responsible for processing the shipping and delivery of any Product(s) purchased by you on the Platform at the time such Product is processed and successfully handed over to the Logistic Partner by us. Our standard dispatch timelines range between 24 (twenty four) hours from the time the Product Order has been placed by you on the Platform. In any case, the user will be provided with an estimated timeline for the delivery of the Product purchased from the Platform. This estimated timeline shall be notified to the user on the order confirmation page displayed at the time the order is confirmed by us. We will also share details about your orders pursuant to their dispatch on the e-mail ID and/or mobile number provided by you/ registered with us. You agree and understand that though we effectuate Product delivery to the Users through our Logistic Partners including Shiprocket, we reserve the right to ship and deliver the Products on our own without engaging any Logistic Partners or third party service providers.
          </Typography>
          
          <Typography component="li" variant="body1" paragraph>
            The Delivery charges of the Platform are as follows:
            <Box component="ul" sx={{ pl: 2, mt: 1 }}>
              <Typography component="li" variant="body1">
                For Non-NFM Customers
                <TableContainer component={Box} sx={{ mt: 1, mb: 2 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Order Value</TableCell>
                        <TableCell>Delivery Charge</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Up to Rs. 199</TableCell>
                        <TableCell>Rs. 69</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Rs. 199 – Rs. 499</TableCell>
                        <TableCell>Rs. 49</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Rs. 499 – Rs. 999</TableCell>
                        <TableCell>Rs. 29</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Rs. 999 or more</TableCell>
                        <TableCell>FREE Shipping</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Typography>
              <Typography component="li" variant="body1">
                For NFM Customers:
                <TableContainer component={Box} sx={{ mt: 1, mb: 2 }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Order Value</TableCell>
                        <TableCell>Delivery Charge</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>Up to Rs. 99</TableCell>
                        <TableCell>Rs. 35</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Rs. 99 or more</TableCell>
                        <TableCell>FREE Shipping</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Typography>
            </Box>
            <Typography variant="body1" paragraph>
              Note: Delivery charges quoted above are applicable on ALL orders available on the Platform.
            </Typography>
          </Typography>
          
          <Typography component="li" variant="body1" paragraph>
            You agree and understand that though we endeavour to ship and deliver our Products all across India through Shiprocket and our other Logistic Partners, we may, in our sole discretion determine a select list of areas which are unserviceable for delivery of Products. We, or our Logistic Partners including Shiprocket, do not provide shipping and delivery services in such unserviceable areas and may not process your orders on the Platform in such cases. In the event, an area has been deemed unserviceable by us, we shall notify such user at the time of placing an order for purchase of Products on the Platform. You may also verify whether an area is unserviceable for deliveries by us by entering the relevant area pin-code on the Platform.
          </Typography>
          
          <Typography component="li" variant="body1" paragraph>
            You agree and acknowledge that to effectuate timely delivery of the purchased Products to you we may inquire or collect specific information like your name, shipping address, billing address, landmarks, contact details, etc. You shall ensure that all information that is submitted by you to us on the Platform is true, complete, accurate and sufficient to identify the actual place of delivery. You understand that you shall bear absolute liability in case of any failure by us in delivering the purchased Products due to your failure to provide correct, complete, sufficient and accurate information at the time of placing the order. It is further clarified that we shall not be liable in any manner and at any point in time due to your failure to provide correct and complete information.
          </Typography>
          
          <Typography component="li" variant="body1" paragraph>
            We will attempt to deliver the purchased Product to your designated address within the estimated timeline of delivery notified to you. In the event you are not available or present to accept the delivery of the Product, our Logistic Partners including Shiprocket will make a maximum of three attempts in 3 (three) days (each attempt everyday) to deliver the purchased Product(s) to you. If the third delivery attempt is unsuccessful and you continue to remain unavailable, we reserve the right to cancel the order of the purchased Products at our sole discretion and process the return of such Product to us. We further reserve the right to deduct the shipping and delivery charges borne by us while processing any refunds subsequent to such cancellation.
          </Typography>
          
          <Typography component="li" variant="body1" paragraph>
            While we make reasonable endeavours in ensuring that purchased Products are delivered to you in a timely manner and within the timeline notified to you, you accept and acknowledge that the delivery may be delayed on account of:
            <Box component="ul" sx={{ pl: 2, mt: 1 }}>
              <Typography component="li" variant="body1">Logistical issues beyond our control;</Typography>
              <Typography component="li" variant="body1">Unsuitable weather conditions;</Typography>
              <Typography component="li" variant="body1">Political disruptions, strikes, employee-lockouts, governmental restrictions, etc;</Typography>
              <Typography component="li" variant="body1">Acts of God such as floods, earthquakes, etc;</Typography>
              <Typography component="li" variant="body1">Other unforeseeable circumstances.</Typography>
            </Box>
            In such events of delay, we shall make reasonable attempt to inform you by writing to your email ID and/or mobile number registered with us. We disclaim all liabilities that may arise on account of our failure to inform or notify you of delays in the delivery of purchased Products on the Platform. Further, we shall be under no obligation to compensate you for any claim that may otherwise arise on account of delay in the shipment or delivery or use of the purchased Products.
          </Typography>
        </Box>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          Customer Support
        </Typography>
        
        <Typography variant="body1" paragraph>
          You may direct any queries or concerns relating to the shipping and delivery of Products as per this Policy to our customer support team who can be contacted at the below mentioned details:
        </Typography>
        
        <Typography variant="body1" paragraph>
          E-mail id - <Link href="mailto:cs@pharmaman.com">cs@pharmaman.com</Link>
        </Typography>
        
        <Typography variant="body1" paragraph>
          Contact No - 72007-12345
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
          Consolidated Shipment Cashback Program Terms and Conditions
        </Typography>
        
        <Typography variant="body1" paragraph>
          This consolidated shipment cashback program ("Cashback Program") is a promotional offer brought by Pharmaman to the users ("Customer" / "you") of www.pharmaman.com ("Pharmaman"). The below mentioned terms ("Terms") govern the terms and conditions for availing the aforesaid Cashback Program.
        </Typography>
        
        <Box component="ol" sx={{ pl: 2 }}>
          <Typography component="li" variant="body1" paragraph>
            Cashback Program: The Customers while placing a pre-paid order on Pharmaman, may opt for the all the products ordered in single order to be delivered in a consolidated shipment. Customers opting for such consolidated shipment at the time of checkout would be eligible to receive a fixed cashback as prescribed under these Terms ("Cashback"). The Cashback shall be available for a period of 90 (ninety) days, or such period as determined by Pharmaman at its sole discretion. The Cashback would be credited to your wallet as 'Pharmaman Cash' upon expiry of return window of the Eligible Products (defined below). If the Customer opts for cash on delivery as a mode of payment for the order or returns any items or the order, whether in part or full, the Customer shall not be eligible for the Cashback.
          </Typography>
          
          <Typography component="li" variant="body1" paragraph>
            Eligible Products: This Cashback Program shall apply to any pharmaceutical, personal care, wellness products, or instruments purchased on Pharmaman, however, shall not apply to such products which fall under the consultation and diagnostic categories ("Eligible Products").
          </Typography>
          
          <Typography component="li" variant="body1" paragraph>
            Cashback credit and utilisation: Upon expiry of return window of the Eligible Products, a fixed cashback amount of INR 20 (Indian Rupees Twenty only) will be credited to a Customer as 'Pharmaman Cash'. The Cashback can be utilised by the Customer as mode of payment for subsequent purchase on Pharmaman.
          </Typography>
          
          <Typography component="li" variant="body1" paragraph>
            Offer Rules:
            <Box component="ul" sx={{ pl: 2, mt: 1 }}>
              <Typography component="li" variant="body1">The Cashback Program is available for the Customer across India.</Typography>
              <Typography component="li" variant="body1">The Cashback can be used for subsequent purchases of Eligible Products made on Pharmaman.</Typography>
              <Typography component="li" variant="body1">The Cashback shall expire automatically if it remains unutilised beyond a period of 90 (ninety) days or such period as determined by Pharmaman in its sole discretion.</Typography>
              <Typography component="li" variant="body1">The Cashback is non-transferable and non-exchangeable for cash or any other items.</Typography>
              <Typography component="li" variant="body1">The Cashback cannot be utilised on any other website or store other than as indicated in these Terms.</Typography>
              <Typography component="li" variant="body1">Pharmaman will not accept any responsibility if the Customer is unable to encash the Cashback within the 90 (ninety) days' period mentioned above.</Typography>
              <Typography component="li" variant="body1">Pharmaman reserves the right to withdraw the Cashback Program at any time it deems fit.</Typography>
              <Typography component="li" variant="body1">Any return of the order of Eligible Products, whether partial or full, shall disqualify the Customer from the Cashback.</Typography>
              <Typography component="li" variant="body1">You can view the Pharmaman Cash balance by clicking on the 'My Wallet' section on the 'My Account' page.</Typography>
              <Typography component="li" variant="body1">In relation to the Cashback Program, the decision of Pharmaman shall be final.</Typography>
            </Box>
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default ShippingPolicy;